import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const DrawerHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 24px",
  backgroundColor: colors.blueLight25,
});

export const DrawerTitle = styled("span")({
  fontFamily: "Manrope",
  fontSize: 16,
  fontWeight: 700,
  color: colors.brandBlue600,
});

const styles = makeStyles(() => ({
  paperProps: {
    backgroundColor: "#F8F9FC !important",
    borderRadius: 10,
    width: "100%",
    maxWidth: 560,
  },
  modalProps: {
    zIndex: "99999 !important" as unknown as number,
    backgroundColor: "rgba(152, 162, 179, 0.5)",
  },
}));

export default styles;
